import InternalStaticAnchorKnowledgeBase from 'models/application/anchor/types/internalStatic/types/KnowledgeBase';

export default class InternalStaticAnchorKnowledgeBaseService {
	toModel() {
		return new InternalStaticAnchorKnowledgeBase();
	}
}
